import { z } from "zod/v4";

// Individual feature data structure
const FeatureDataSchema = z.object({
  id: z.number().optional(), // undefined = new feature, number = existing feature
  feature: z.number().optional(), // feature table ID (for existing features)
  feature_name: z.string().min(1, "Feature name is required"),
});

export type FeatureData = z.infer<typeof FeatureDataSchema>;

// For final form submission - at least one feature is required
export const TestedFeaturesSchema = z
  .array(FeatureDataSchema)
  .min(1, "At least one tested feature is required");

// For draft form - same structure, features are optional
export const TestedFeaturesDraftSchema = z.array(FeatureDataSchema);

export type TestedFeaturesFormValues = z.infer<typeof TestedFeaturesSchema>;
